<template>
  <div class="form-group">
    <label v-if="label" :for="inputId" class="form-label">
      {{ label }}
      <span v-if="required" class="required">*</span>
    </label>
    <input
      :id="inputId"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :class="['form-control', inputClass, { 'is-invalid': error }]"
      @input="$emit('update:modelValue', $event.target.value)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <small v-if="helpText && !error" class="form-text">{{ helpText }}</small>
    <div v-if="error" class="invalid-feedback">{{ error }}</div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'BaseInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: (v) => ['text', 'email', 'password', 'tel', 'number', 'url'].includes(v)
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    helpText: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    inputClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  emits: ['update:modelValue', 'blur', 'focus'],
  setup(props) {
    const inputId = computed(() => props.id || `input-${Math.random().toString(36).substr(2, 9)}`)
    return { inputId }
  }
}
</script>
